import {QuestionSetLabel} from "./question-set-label";
import {Scale} from "./scale";
import { QuestionType } from "./question-type";
import { FlaggedCondition } from "app/shared/models/flagged-condition";

export abstract class Question
{
	private _id:string;
	private _prompt:string;
	private _type:QuestionType;
	private _display_order:number;
	private _is_reversed:boolean;
	private _scale:Scale;

	private _skip_scoring:boolean;
	private _display_index:number;
	private _flaggedCondition:FlaggedCondition;
	private _is_flagged:boolean;
	/**
	 * The score that was calculated for this individual question if applicable.
	 */
	private _computedScore:number;
	
	constructor() {
		this.id = null;
		this.prompt = "";
		this.display_order = 0;
		this.is_reversed = false;
		this.assessment_scale = null;
		this.skip_scoring = false;
		this._display_index = 0;
		this._flaggedCondition = null;
		this.isFlaggedForReview = false;
		this._computedScore = null;
	}

	public get type() : QuestionType {
		return this._type;
	}
	public set type(v:QuestionType) {
		this._type = v;
	}

	public get display_index() : number {
		return this._display_index;
	}

	public set display_index(v:number) {
		this._display_index = v;
	}
	
	public get id() : string {
		return this._id;
	}
	
	public set id(v : string) {
		this._id = v;
	}
	
	
	public get prompt() : string {
		return this._prompt;
	}
	
	public set prompt(v : string) {
		this._prompt = v;
	}
	
	public get display_order() : number {
		return this._display_order;
	}
	
	public set display_order(v : number) {
		this._display_order = v;
	}
	
	public get is_reversed() : boolean {
		return this._is_reversed;
	}
	
	public set is_reversed(v : boolean) {
		this._is_reversed = v;
	}
	
	public get skip_scoring() : boolean {
		return this._skip_scoring;
	}
	
	public set skip_scoring(v : boolean) {
		this._skip_scoring = v;
	}
	
	public get assessment_scale() : Scale {
		return this._scale;
	}
	
	public set assessment_scale(v : Scale) {
		this._scale = v;
	}

	public get hasFlagCondition(): boolean {
		return this._flaggedCondition != null;
	}

	public get flaggedCondition(): FlaggedCondition {
		return this._flaggedCondition;
	}

	public set flaggedCondition(value: FlaggedCondition) {
		this._flaggedCondition = value;
	}

	public abstract get answerDisplayText();

	public abstract get answerForSave();

	public abstract setSavedAnswer(data:any, labels:QuestionSetLabel[]);

	public abstract hasAnswer(answer:any);

	public setComputedScore(v:number) {
		this._computedScore = v;
	}
	public getComputedScore() {
		return this._computedScore;
	}

	public abstract get isFilledOut() : boolean;

	public get isFlaggedForReview() {
		return this._is_flagged;
	}

	public set isFlaggedForReview(v:boolean) {
		this._is_flagged = v;
	}

	
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question.ts